<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('审核状态')" prop="contractStatus">
                <a-select :placeholder="$t('请选择')+$t('审核状态')" v-model="queryParam.contractStatus" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.ExtraApplyStatusEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('内部商户号')" prop="merInnerNo">
                <a-input v-model="queryParam.merInnerNo" :maxLength="32" :placeholder="$t('请输入')+$t('内部商户号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商户注册名称')" prop="merRegName">
                <a-input v-model="queryParam.merRegName" :maxLength="32" :placeholder="$t('请输入')+$t('商户注册名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="商户经营名称" prop="merBizName">
                  <a-input v-model="queryParam.merBizName" :maxLength="32" :placeholder="$t('请输入')+'商户经营名称'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="营业执照名称" prop="merBlisName">
                  <a-input v-model="queryParam.merBlisName" :maxLength="32" :placeholder="$t('请输入')+'营业执照名称'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="营业执照号" prop="merBlis">
                  <a-input v-model="queryParam.merBlis" :maxLength="32" :placeholder="$t('请输入')+'营业执照号'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="法人姓名" prop="larName">
                  <a-input v-model="queryParam.larName" :maxLength="32" :placeholder="$t('请输入')+'法人姓名'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="法人身份证号码" prop="larIdcard">
                  <a-input v-model="queryParam.larIdcard" :maxLength="32" :placeholder="$t('请输入')+'法人身份证号码'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="商户联系人手机" prop="merContactMobile">
                  <a-input v-model="queryParam.merContactMobile" :maxLength="32" :placeholder="$t('请输入')+'商户联系人手机号码'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="商户联系人" prop="merContactName">
                  <a-input v-model="queryParam.merContactName" :maxLength="32" :placeholder="$t('请输入')+'商户联系人'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算账户开户行号" prop="openingBankCode">
                  <a-input v-model="queryParam.openingBankCode" :maxLength="32" :placeholder="$t('请输入')+'结算账户开户行号'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算账户开户行名称" prop="openingBankName">
                  <a-input v-model="queryParam.openingBankName" :maxLength="32" :placeholder="$t('请输入')+'结算账户开户行名称'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算账户账号" prop="acctNo">
                  <a-input v-model="queryParam.acctNo" :maxLength="32" :placeholder="$t('请输入')+'结算账户账号'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算账户名称" prop="acctName">
                  <a-input v-model="queryParam.acctName" :maxLength="32" :placeholder="$t('请输入')+'结算账户名称'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算周期" prop="settlePeriod">
                  <a-select v-model="queryParam.settlePeriod" :placeholder="$t('请输入')+'结算周期'">
                    <a-select-option v-for="(item, index) in customDict.SettleCycleEnum" :value="item.type" :key="index">{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="进件ID" prop="contractId">
                  <a-input v-model="queryParam.contractId" :maxLength="32" :placeholder="$t('请输入')+'进件ID'" allow-clear/>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item label="银联商户号" prop="merCupNo">
                  <a-input v-model="queryParam.merCupNo" :maxLength="32" :placeholder="$t('请输入')+'银联商户号'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                     :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 " :sm="6">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="single" @click="$refs.simpleCreateForm.handleUpdate(undefined, ids)" v-hasPermi="['merchant:extraapplychinaums:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['merchant:extraapplychinaums:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :merchantId="merchantId"
        :merchantType="merchantType"
        @ok="getList"
      />
      <chinaums-balance ref="chinaumsBalance"/>
      <simple-create-form
        ref="simpleCreateForm"
        :merchantId="merchantId"
        :merchantType="merchantType"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '1200' }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="contractStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.ExtraApplyStatusEnum" :value="record.contractStatus"/>
        </span>
        <span slot="splitStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.ExtraSplitStatusEnum" :value="record.splitStatus"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.simpleCreateForm.handleUpdate(record, undefined)" v-hasPermi="['merchant:extraapplychinaums:edit']">
             <a-icon type="edit" />{{$t('修改进件信息')}}
            <br>
          </a>
          <a @click="handleChinaumsApply(record)" style="color: #f30202"  v-if="!record.contractId">
            <a-icon type="edit" />进件
            <br>
          </a>
          <a @click="handleChinaumsApply(record)"  style="color: #f30202" v-if="record.contractStatus==='MANUAL_AUDIT' || record.contractStatus==='INNER_CHECK_REJECTED' ">
            <a-icon type="edit" />重新进件
             <br>
          </a>
          <a @click="handleChinaumsEdit(record)"  v-if="false ">
            <a-icon type="edit" />修改进件<br>
          </a>
           <a  @click="$refs.chinaumsBalance.handleDetail(record.id)" v-if="record.merNo">
            <a-icon type="eye" />查看账户余额<br>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageExtraApplyUms,
  updateExtraApplyUms,
  extraApplyUmsApply
} from '@/api/merchant/extraApplyChinaums'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import SimpleCreateForm from './modules/SimpleCreateForm.vue'
import ChinaumsBalance from './modules/ChinaumsBalance.vue'

import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'extraapplychinaums',
  components: {
    CustomDictTag,
    CreateForm,
    SimpleCreateForm,
    ChinaumsBalance
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      merchantId: undefined,
      merchantType: undefined,
      // 查询参数
      queryParam: {
        merchantId: undefined,
        orderNo: undefined,
        posType: undefined,
        orgCode: undefined,
        merRegName: undefined,
        merBizName: undefined,
        merRegDistCode: undefined,
        merRegAddr: undefined,
        mccCode: undefined,
        merBlisName: undefined,
        merBlis: undefined,
        merBlisStDt: undefined,
        merBlisExpDt: undefined,
        larName: undefined,
        larIdType: undefined,
        larIdcard: undefined,
        larIdcardStDt: undefined,
        larIdcardExpDt: undefined,
        merContactMobile: undefined,
        merContactName: undefined,
        shopName: undefined,
        shopDistCode: undefined,
        shopAddr: undefined,
        shopContactName: undefined,
        shopContactMobile: undefined,
        openingBankCode: undefined,
        openingBankName: undefined,
        clearingBankCode: undefined,
        acctNo: undefined,
        acctName: undefined,
        acctTypeCode: undefined,
        settlePeriod: undefined,
        clearDt: undefined,
        acctIdType: undefined,
        acctIdcard: undefined,
        acctIdDt: undefined,
        devSerialNo: undefined,
        devTypeName: undefined,
        termVer: undefined,
        salesStaff: undefined,
        termNum: undefined,
        retUrl: undefined,
        feeData: undefined,
        fileData: undefined,
        contractNo: undefined,
        feeAssumeType: undefined,
        amountOfMonth: undefined,
        serviceFee: undefined,
        contractId: undefined,
        contractStatus: undefined,
        contractMemo: undefined,
        merInnerNo: undefined,
        merCupNo: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商户名称'),
          dataIndex: 'merName',
          align: 'center'
        },
        {
          title: this.$t('进件状态'),
          dataIndex: 'contractStatus',
          scopedSlots: { customRender: 'contractStatus' },
          align: 'center'
        },
        {
          title: this.$t('审核理由'),
          dataIndex: 'contractMemo',
          align: 'center'
        },
        {
          title: this.$t('分账状态'),
          dataIndex: 'splitStatus',
          scopedSlots: { customRender: 'splitStatus' },
          align: 'center'
        },
        {
          title: this.$t('银联商户号'),
          dataIndex: 'mid',
          align: 'center'
        },
        {
          title: this.$t('终端号'),
          dataIndex: 'tid',
          align: 'center'
        },
        // {
        //   title: this.$t('营业执照名称'),
        //   dataIndex: 'merBlisName',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('营业执照编号'),
        //   dataIndex: 'merBlis',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('法人姓名'),
        //   dataIndex: 'larName',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('法人身份证号码'),
        //   dataIndex: 'larIdcard',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('商户联系人手机'),
        //   dataIndex: 'merContactMobile',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('商户联系人'),
        //   dataIndex: 'merContactName',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('结算账户开户行名称'),
        //   dataIndex: 'openingBankName',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('结算账户账号'),
        //   dataIndex: 'acctNo',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('结算账户名称'),
        //   dataIndex: 'acctName',
        //   align: 'center'
        // },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: 150,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.pushMerchantId()
    this.getList()
  },
  mounted() {
    this.pushMerchantId()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    pushMerchantId() {
      let merchantId = this.$route.query.merchantId;
      if (merchantId) {
        this.merchantId = merchantId;
        this.merchantType = Number(this.$route.query.merchantType);
      }
    },
    /** 查询商家进件-拉卡拉列表 */
    getList () {
      this.loading = true
      this.queryParam.merchantId = this.merchantId
      pageExtraApplyUms(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    handleAdd() {
      //查询有没有进件记录
      this.$refs.createForm.handleAdd(this.merchantId, this.total);
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        merchantId: undefined,
        orderNo: undefined,
        posType: undefined,
        orgCode: undefined,
        merRegName: undefined,
        merBizName: undefined,
        merRegDistCode: undefined,
        merRegAddr: undefined,
        mccCode: undefined,
        merBlisName: undefined,
        merBlis: undefined,
        merBlisStDt: undefined,
        merBlisExpDt: undefined,
        larName: undefined,
        larIdType: undefined,
        larIdcard: undefined,
        larIdcardStDt: undefined,
        larIdcardExpDt: undefined,
        merContactMobile: undefined,
        merContactName: undefined,
        shopName: undefined,
        shopDistCode: undefined,
        shopAddr: undefined,
        shopContactName: undefined,
        shopContactMobile: undefined,
        openingBankCode: undefined,
        openingBankName: undefined,
        clearingBankCode: undefined,
        acctNo: undefined,
        acctName: undefined,
        acctTypeCode: undefined,
        settlePeriod: undefined,
        clearDt: undefined,
        acctIdType: undefined,
        acctIdcard: undefined,
        acctIdDt: undefined,
        devSerialNo: undefined,
        devTypeName: undefined,
        termVer: undefined,
        salesStaff: undefined,
        termNum: undefined,
        retUrl: undefined,
        feeData: undefined,
        fileData: undefined,
        contractNo: undefined,
        feeAssumeType: undefined,
        amountOfMonth: undefined,
        serviceFee: undefined,
        contractId: undefined,
        contractStatus: undefined,
        contractMemo: undefined,
        merInnerNo: undefined,
        merCupNo: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleChinaumsApply(record) {
      this.loading = true
      extraApplyUmsApply({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("进件成功待审核",3)
          this.getList()
        }
      })
    },
    handleChinaumsEdit(record) {
      this.loading = true
      updateExtraApplyUms({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("进件修改成功待审核",3)
          this.getList()
        }
      })
    },



  }
}
</script>
